import Vue from 'vue';
import Router from 'vue-router';
const Home = () => import('./views/home.vue');
const Caiji = () => import('./views/caiji.vue');
const Report = () => import('./views/report.vue');

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/caiji',
      name: 'caiji',
      component: Caiji,
      // meta: { requiresAuth: true }
    },
    {
      path: '/report',
      name: 'report',
      component: Report,
      // meta: { requiresAuth: true }
    }
  ]
});

// 路由守卫
router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
